module.exports = __webpack_public_path__ + "img/headImg.6d0ffd48.png";